import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { format } from 'date-fns';
import { IAccountDynamicsFilter } from '@pages/AccountsDynamics/List/filter';
import { parseFilenameFromContentDisposition, triggerBlobDownload } from '@app/utils/file';
import { sleep } from '@app/utils/date';

export const fetch = async (filters: IAccountDynamicsFilter): Promise<{ hashrate: number }> => {
  let data = {};

  if (filters.search?.length) {
    data = { ...data, q: filters.search };
  }

  if (filters.dateFrom) {
    data = {
      ...data,
      date_from: format(new Date(filters.dateFrom), 'yyyy-MM-dd'),
    };
  }

  if (filters.dateTo) {
    data = {
      ...data,
      date_to: format(new Date(filters.dateTo), 'yyyy-MM-dd'),
    };
  }

  if (filters.sort) {
    data = {
      ...data,
      sort_order: filters.sort.type,
      sort_by: filters.sort.column,
    };
  }

  const response = await api.get(`${BI_BASE_URL}/dynamic/hashrate`, {
    params: {
      managers_ids: filters.managers,
      region: filters.regions,
      source: filters.sources,
      tags: filters.tags,
      accounts: filters.accounts,
      account_type: filters.accountType,
      activities: filters.activity,
      account_statuses: filters.created_at,
      export_xlsx: true,
      ...data,
    },
  });

  return response.data ?? [];
};

export const useAccountDynamicsTotalHashrate = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
